import React, { useState, useEffect } from 'react';
import { db } from './firebaseConfig';
import { collection, getDocs, query, orderBy, addDoc, doc, updateDoc, deleteDoc } from 'firebase/firestore';
import { toast } from 'react-toastify';
import ManutencaoModal from './ManutencaoModal';

// Imports dos componentes MUI
import {
  Box, Button, Typography, Paper, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, IconButton
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import BuildIcon from '@mui/icons-material/Build';

// Componente de confirmação
const ConfirmacaoToast = ({ closeToast, onConfirm, message }) => (
    <div>
      <p>{message}</p>
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '10px' }}>
        <Button size="small" variant="contained" color="error" onClick={() => { onConfirm(); closeToast(); }}>Sim, Excluir</Button>
        <Button size="small" variant="outlined" color="inherit" onClick={closeToast}>Não</Button>
      </div>
    </div>
);

const Manutencao = () => {
  const [manutencoes, setManutencoes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [manutencaoParaEditar, setManutencaoParaEditar] = useState(null);
  
  const fetchManutencoes = async () => {
    setLoading(true);
    try {
      const collectionRef = collection(db, 'manutencoes');
      const q = query(collectionRef, orderBy('dataInicio', 'desc'));
      const querySnapshot = await getDocs(q);
      setManutencoes(querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    } catch (error) {
      toast.error("Erro ao carregar agendamentos.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchManutencoes();
  }, []);

  const handleSave = async (dados) => {
    try {
      if (manutencaoParaEditar) {
        const docRef = doc(db, 'manutencoes', manutencaoParaEditar.id);
        await updateDoc(docRef, dados);
        toast.success('Agendamento atualizado com sucesso!');
      } else {
        await addDoc(collection(db, 'manutencoes'), dados);
        toast.success('Manutenção agendada com sucesso!');
      }
      setIsModalOpen(false);
      setManutencaoParaEditar(null);
      fetchManutencoes();
    } catch (error) {
      toast.error("Erro ao salvar agendamento.");
    }
  };

  const handleExcluir = (id, chaleNome) => {
    const deletar = async () => {
        try {
            await deleteDoc(doc(db, 'manutencoes', id));
            toast.success('Agendamento excluído com sucesso!');
            fetchManutencoes();
        } catch (error) {
            toast.error("Erro ao excluir agendamento.");
        }
    };
    toast.warn(
      <ConfirmacaoToast 
        message={`Excluir agendamento para o ${chaleNome}?`}
        onConfirm={deletar}
      />, { position: "top-center", autoClose: false });
  };

  const abrirModal = (manutencao = null) => {
    setManutencaoParaEditar(manutencao);
    setIsModalOpen(true);
  };

  const formatarData = (dataString) => {
    if (!dataString) return 'N/A';
    const [ano, mes, dia] = dataString.split('-');
    return `${dia}/${mes}/${ano}`;
  };

  return (
    <Box sx={{ padding: 3, backgroundColor: 'background.default', minHeight: '100vh' }}>
      <Paper sx={{ padding: 2, marginBottom: 3 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <BuildIcon color="primary" />
            <Typography variant="h5" component="h1" fontWeight="600">
              Gestão de Manutenções
            </Typography>
          </Box>
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={() => abrirModal()}
          >
            Agendar Manutenção
          </Button>
        </Box>
      </Paper>

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow>
              <TableCell sx={{fontWeight: 'bold'}}>Chalé</TableCell>
              <TableCell sx={{fontWeight: 'bold'}}>Período</TableCell>
              <TableCell sx={{fontWeight: 'bold'}}>Motivo</TableCell>
              <TableCell align="center" sx={{fontWeight: 'bold'}}>Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
                <TableRow><TableCell colSpan={4} align="center">Carregando...</TableCell></TableRow>
            ) : manutencoes.map(item => (
              <TableRow key={item.id} hover>
                <TableCell>{item.chaleNome}</TableCell>
                <TableCell>{formatarData(item.dataInicio)} a {formatarData(item.dataFim)}</TableCell>
                <TableCell>{item.motivo || 'Não especificado'}</TableCell>
                <TableCell align="center">
                  <IconButton color="primary" onClick={() => abrirModal(item)} title="Editar">
                    <EditIcon />
                  </IconButton>
                  <IconButton color="error" onClick={() => handleExcluir(item.id, item.chaleNome)} title="Excluir">
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      
      {isModalOpen && (
        <ManutencaoModal 
          onClose={() => {
            setIsModalOpen(false);
            setManutencaoParaEditar(null);
          }}
          onSave={handleSave}
          manutencaoParaEditar={manutencaoParaEditar}
        />
      )}
    </Box>
  );
};

export default Manutencao;